export default `
// STEP 1 - Enter the element ID:
const elementId = '';

// STEP 2 (optional) - Enter a CSS class to add:
const addClass = '';

// STEP 3 (optional) - Enter a CSS class to remove:
const removeClass = '';



/////// PLEASE DO NOT MODIFY ANY CODE BELOW THIS LINE ///////



const element = document.getElementById(elementId);

if (element) {
    if (addClass) {
        element.classList.add(addClass);
    }

    if (removeClass) {
        element.classList.remove(removeClass);
    }
}
`;
